import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { getContentKeyAccToLang } from '../../../utils/utils';
import { ErrorText, RadioButton, RowView } from '../../CorporateForm/components';
import Button from '../../../components/Button';
import CustomInput from '../../../components/CustomInput';
import dynamicfunction from '../../../utils/dynamicfunction';
import { useNavigate } from 'react-router';
import { logoutUser } from '../../../store/actions/authActions';
import individual_general_information_validation_schema from '../../../validations_schemas/individual_general_information_schema';
import { getIndGeneralInformationData, postIndGeneralInformation, saveIndKycGeneralInformation } from '../../../store/actions/individualAction';
import { digitsOnly } from '../../../utils/functions';

const GeneralInformation = ({ onDone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isArabic } = dynamicfunction();

  const { individualContent, language } = useSelector((state) => state.content);
  const { ind_post_loading, ind_general_information_data } = useSelector((state) => state.individual);

  const { client_application_id, is_kyc } = useSelector((state) => state.constant);

  const getContent = (key) => {
    return getContentKeyAccToLang(individualContent?.general_information?.data?.attributes, key, isArabic);
  };

  useEffect(() => {
    getData();
  }, [language]);

  const getData = async () => {
    await dispatch(
      getIndGeneralInformationData(client_application_id),
    );
  }


  const onSubmit = (values) => {
    const api_data = {
      ...ind_general_information_data,
      areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany:
        values?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany === '1' ? true : false,
      describeNameOfTheCompany: values?.describeNameOfTheCompany,
      areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany:
        values?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany === '1' ? true : false,
      describeYourRelationToTheBoardOfMember: values?.describeYourRelationToTheBoardOfMember,
      areYouEntrustedWithAProminentPosition: values?.areYouEntrustedWithAProminentPosition === '1' ? true : false,
      pleaseSpecifyYourFunctionOrPositionAndYourInstitution: values?.pleaseSpecifyYourFunctionOrPositionAndYourInstitution,
      doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition:
        values?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition === '1' ? true : false,
      pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution: values?.pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution,
      willYouBeTheBeneficialOwnerOfThisAccount: values?.willYouBeTheBeneficialOwnerOfThisAccount === '1' ? true : false,
      nameOfTheBeneficialOwner: values?.nameOfTheBeneficialOwner,
      beneficiaryIdNumber: values?.beneficiaryIdNumber,
    };

    dispatch(
      is_kyc
        ? saveIndKycGeneralInformation(api_data, (res) => {
          values?.isSaveExist ? navigate('/funds/available-funds') : onDone();
        })
        : postIndGeneralInformation(api_data, (res) => {
          values?.isSaveExist ? dispatch(logoutUser()) : onDone();
        }),
    );
  };

  const optionsYesOrNO = [
    { id: 1, name: getContent('yes') },
    { id: 0, name: getContent('no') },
  ];

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany:
            ind_general_information_data?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany === true
              ? '1'
              : ind_general_information_data?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany ===
                false
                ? '0'
                : '',
          describeNameOfTheCompany: ind_general_information_data?.describeNameOfTheCompany ?? '',
          areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany:
            ind_general_information_data?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany ===
              true
              ? '1'
              : ind_general_information_data?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany ===
                false
                ? '0'
                : '',
          describeYourRelationToTheBoardOfMember: ind_general_information_data?.describeYourRelationToTheBoardOfMember ?? '',
          areYouEntrustedWithAProminentPosition:
            ind_general_information_data?.areYouEntrustedWithAProminentPosition === true
              ? '1'
              : ind_general_information_data?.areYouEntrustedWithAProminentPosition === false
                ? '0'
                : '',
          pleaseSpecifyYourFunctionOrPositionAndYourInstitution:
            ind_general_information_data?.pleaseSpecifyYourFunctionOrPositionAndYourInstitution ?? '',
          doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition:
            ind_general_information_data?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition === true
              ? '1'
              : ind_general_information_data?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition === false
                ? '0'
                : '',
          pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution:
            ind_general_information_data?.pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution ?? '',
          willYouBeTheBeneficialOwnerOfThisAccount:
            ind_general_information_data?.willYouBeTheBeneficialOwnerOfThisAccount === true
              ? '1'
              : ind_general_information_data?.willYouBeTheBeneficialOwnerOfThisAccount === false
                ? '0'
                : '',
          nameOfTheBeneficialOwner: ind_general_information_data?.nameOfTheBeneficialOwner ?? '',
          beneficiaryIdNumber:
            ind_general_information_data?.beneficiaryIdNumber ?? '',
          isSaveExist: false,
        }}
        validationSchema={individual_general_information_validation_schema}
        onSubmit={(values) => {
          onSubmit(values);
        }}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({ handleSubmit, setFieldValue, values, errors, setFieldTouched, touched }) => {
          return (
            <div className=''>
              <div className='pt-3 sm:pt-5'>
                <RadioButton
                  label={getContent('is_board_director_member')}
                  required={true}
                  value={values?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany}
                  onChange={(e) => {
                    setFieldValue('areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', e);
                    setFieldTouched('areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', false);
                  }}
                  options={optionsYesOrNO}
                />
                <ErrorText
                  text={getContent(
                    touched?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany
                      ? errors?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany
                      : '',
                  )}
                />
              </div>
              {values?.areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany?.toString() === '1' && (
                <RowView className='gap-7' isResponsive>
                  <CustomInput
                    isRounded
                    isRequired={true}
                    maxLength={30}
                    label={getContent('company_name')}
                    placeholder={getContent('please_specify')}
                    value={values?.describeNameOfTheCompany}
                    onChange={(e) => {
                      setFieldValue('describeNameOfTheCompany', e.target.value);
                      setFieldTouched('describeNameOfTheCompany', true, false);
                    }}
                    errorMessage={getContent(touched?.describeNameOfTheCompany ? errors?.describeNameOfTheCompany : '')}
                  />
                </RowView>
              )}

              <div className='pt-3 sm:pt-5'>
                <RadioButton
                  label={getContent('is_related_board_member')}
                  required={true}
                  value={values?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany}
                  onChange={(e) => {
                    setFieldValue('areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', e);
                    setFieldTouched(
                      'areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany',
                      false,
                    );
                  }}
                  options={optionsYesOrNO}
                />
                <ErrorText
                  text={getContent(
                    touched?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany
                      ? errors?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany
                      : '',
                  )}
                />
              </div>
              {values?.areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany?.toString() ===
                '1' && (
                  <RowView className='gap-7' isResponsive>
                    <CustomInput
                      isRounded
                      isRequired={true}
                      maxLength={30}
                      label={getContent('please_specify')}
                      placeholder={getContent('please_specify')}
                      value={values?.describeYourRelationToTheBoardOfMember}
                      onChange={(e) => {
                        setFieldValue('describeYourRelationToTheBoardOfMember', e.target.value);
                        setFieldTouched('describeYourRelationToTheBoardOfMember', true, false);
                      }}
                      errorMessage={getContent(touched?.describeYourRelationToTheBoardOfMember ? errors?.describeYourRelationToTheBoardOfMember : '')}
                    />
                  </RowView>
                )}

              <div className='pt-3 sm:pt-5'>
                <RadioButton
                  label={getContent('is_assigned_high_level_position')}
                  required={true}
                  value={values?.areYouEntrustedWithAProminentPosition}
                  onChange={(e) => {
                    setFieldValue('areYouEntrustedWithAProminentPosition', e);
                    setFieldTouched('areYouEntrustedWithAProminentPosition', false);
                  }}
                  options={optionsYesOrNO}
                />
                <ErrorText text={getContent(touched?.areYouEntrustedWithAProminentPosition ? errors?.areYouEntrustedWithAProminentPosition : '')} />
              </div>
              {values?.areYouEntrustedWithAProminentPosition?.toString() === '1' && (
                <RowView className='gap-7' isResponsive>
                  <CustomInput
                    isRounded
                    isRequired={true}
                    maxLength={30}
                    label={getContent('please_specify')}
                    placeholder={getContent('please_specify')}
                    value={values?.pleaseSpecifyYourFunctionOrPositionAndYourInstitution}
                    onChange={(e) => {
                      setFieldValue('pleaseSpecifyYourFunctionOrPositionAndYourInstitution', e.target.value);
                      setFieldTouched('pleaseSpecifyYourFunctionOrPositionAndYourInstitution', true, false);
                    }}
                    errorMessage={getContent(
                      touched?.pleaseSpecifyYourFunctionOrPositionAndYourInstitution
                        ? errors?.pleaseSpecifyYourFunctionOrPositionAndYourInstitution
                        : '',
                    )}
                  />
                </RowView>
              )}

              <div className='pt-3 sm:pt-5'>
                <RadioButton
                  label={getContent('is_related_to_assigned_high_level_person')}
                  required={true}
                  value={values?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition}
                  onChange={(e) => {
                    setFieldValue('doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition', e);
                    setFieldTouched('doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition', false);
                  }}
                  options={optionsYesOrNO}
                />
                <ErrorText
                  text={getContent(
                    touched?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition
                      ? errors?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition
                      : '',
                  )}
                />
              </div>
              {values?.doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition?.toString() === '1' && (
                <RowView className='gap-7' isResponsive>
                  <CustomInput
                    isRounded
                    isRequired={true}
                    maxLength={30}
                    label={getContent('please_specify')}
                    placeholder={getContent('please_specify')}
                    value={values?.pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution}
                    onChange={(e) => {
                      setFieldValue('pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution', e.target.value);
                      setFieldTouched('pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution', true, false);
                    }}
                    errorMessage={getContent(
                      touched?.pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution
                        ? errors?.pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution
                        : '',
                    )}
                  />
                </RowView>
              )}

              <div className='pt-3 sm:pt-5'>
                <RadioButton
                  label={getContent('is_beneficial_owner')}
                  required={true}
                  value={values?.willYouBeTheBeneficialOwnerOfThisAccount}
                  onChange={(e) => {
                    setFieldValue('willYouBeTheBeneficialOwnerOfThisAccount', e);
                    setFieldTouched('willYouBeTheBeneficialOwnerOfThisAccount', false);
                  }}
                  options={optionsYesOrNO}
                />
                <ErrorText
                  text={getContent(
                    touched?.willYouBeTheBeneficialOwnerOfThisAccount ? errors?.willYouBeTheBeneficialOwnerOfThisAccount : ''
                  )}
                />
              </div>
              {values?.willYouBeTheBeneficialOwnerOfThisAccount?.toString() === '0' && (
                <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
                  <CustomInput
                    isRounded
                    isRequired={true}
                    label={getContent('beneficiary_name')}
                    placeholder={getContent('enter_name')}
                    value={values?.nameOfTheBeneficialOwner}
                    onChange={(e) => {
                      setFieldValue('nameOfTheBeneficialOwner', e.target.value);
                      setFieldTouched('nameOfTheBeneficialOwner', true, false);
                    }}
                    maxLength={30}
                    errorMessage={getContent(
                      touched?.nameOfTheBeneficialOwner ? errors?.nameOfTheBeneficialOwner : ''
                    )}
                  />
                  <CustomInput
                    isRounded
                    isRequired={true}
                    label={getContent('beneficiary_id_number')}
                    placeholder={getContent('enter_number')}
                    value={values?.beneficiaryIdNumber}
                    onChange={(e) => {
                      const value = e.target.value
                      if (value === '' || digitsOnly.test(value)) {
                        setFieldValue('beneficiaryIdNumber', value);
                        setFieldTouched('beneficiaryIdNumber', true, false);
                      }
                    }}
                    maxLength={10}
                    errorMessage={getContent(
                      touched?.beneficiaryIdNumber
                        ? errors?.beneficiaryIdNumber
                        : ''
                    )}
                  />
                </RowView>
              )}

              <div className='w-full h-0.5 bg-border mt-3 sm:mt-5'></div>

              <RowView className='gap-3 sm:gap-7 pt-3 sm:pt-5'>
                <Button
                  text={getContent('save_proceed')}
                  color={'text-white hover:text-primary '}
                  bgColor='bg-primary hover:bg-transparent hover:border-primary'
                  className={'border border-transparent w-44 px-0 text-center'}
                  type={'submit'}
                  loading={ind_post_loading}
                  isDisabled={ind_post_loading}
                  onClick={() => {
                    setFieldValue('isSaveExist', false);
                    handleSubmit();
                  }}
                />
                <Button
                  text={getContent('save_exit')}
                  color={'text-primary hover:text-white'}
                  bgColor='bg-white hover:bg-primary'
                  className={'border border-primary w-44 px-0 text-center'}
                  isDisabled={ind_post_loading}
                  onClick={() => {
                    setFieldValue('isSaveExist', true);
                    handleSubmit();
                  }}
                />
              </RowView>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default GeneralInformation;
